import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import WeekSelector from "./weekSelector";
import DriverSelector from "../components/driverSelector";
import { useTranslation } from 'react-i18next';


const EditFreeNowInfo = () => {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        driver_id: "",
        week_number: null,
        cash: "",
        brutto: "",
        saldo_freenow: "",
        bonus: "",
        tips: ""
    });
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const navigate = useNavigate();
    const { id } = useParams();  // Дістаємо id з URL

    const fetchUsers = useCallback(async () => {
        try {
            const response = await axios.get("https://godrive.com.pl/api/users");
            const formattedUsers = response.data.map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`
            }));
            setUsers(formattedUsers);
        } catch (error) {
            console.error("❌ Помилка завантаження користувачів:", error);
        }
    }, []);

    const fetchFreeNowById = useCallback(async () => {
        if (!id) return;

        try {
            const response = await axios.get(`https://godrive.com.pl/api/freenow/record/${id}`);
            const data = response.data;

            setFormData({
                week_number: data.week_number,
                cash: data.cash,
                brutto: data.brutto,
                saldo_freenow: data.saldo_freenow,
                bonus: data.bonus,
                tips: data.tips
            });

            // Вибираємо користувача в списку за його id
            const user = users.find(user => user.label.includes(data.driver_firstName) && user.label.includes(data.driver_lastName));
            setSelectedUser(user || null);
        } catch (error) {
            console.error("❌ Помилка завантаження даних FreeNow:", error);
        }
    }, [id, users]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    useEffect(() => {
        fetchFreeNowById();
    }, [fetchFreeNowById, users]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!selectedUser || !selectedUser.label) {
            alert(t("chooseDriverAlert"));
            return;
        }

           
        // Створюємо об'єкт даних для відправки, а не масив значень
        const dataToSend = [{
            driver_firstName: selectedUser.label.split(" ")[0],
            driver_lastName: selectedUser.label.split(" ")[1] || "",
            week_number: parseInt(formData.week_number) || 0,
            cash: parseFloat(formData.cash) || 0,
            brutto: parseFloat(formData.brutto) || 0,
            saldo_freenow: parseFloat(formData.saldo_freenow) || 0,
            bonus: parseFloat(formData.bonus) || 0,
            tips: parseFloat(formData.tips) || 0
        }];
    
        console.log("🔍 Дані, що відправляються:", dataToSend);
    
        try {
            if (id) {
                console.log(`🔄 Відправляємо PUT запит на: /api/freenow/record/${id}`);
                const response = await axios.put(`https://godrive.com.pl/api/freenow/record/${id}`, dataToSend);
                console.log("✅ Запис успішно оновлено:", response.data);
            } else {
                console.log("🆕 Відправляємо POST запит на створення нового запису.");
                const response = await axios.post("https://godrive.com.pl/api/add-freenow-data", dataToSend);
                console.log("✅ Новий запис створено:", response.data);
            }
            navigate("/edit-freenow-info");
        } catch (error) {
            console.error("❌ Помилка збереження FreeNow даних:", error.response?.data || error);
            alert(`❌ Серверна помилка: ${JSON.stringify(error.response?.data || error.message)}`);
        }
    };
        
        
    

    return (
        <Container>
            <h2>{id ? t("edit") : t("add")} {t("data").toLocaleLowerCase()} FreeNow</h2>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            
                            <DriverSelector selectedDriver={selectedUser} setSelectedDriver={setSelectedUser} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                           
                            <WeekSelector selectedWeek={formData.week_number} setSelectedWeek={(week) => setFormData({ ...formData, week_number: week })} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Card className="p-3 border bg-light">
                            <Form.Group><Form.Label>Zrobki przed odliczeniem prowizii (Brutto)</Form.Label><Form.Control type="number" name="brutto" value={formData.brutto} onChange={handleChange} /></Form.Group>
                            <Form.Group><Form.Label>Saldo FreeNow (PayOut)</Form.Label><Form.Control type="number" name="saldo_freenow" value={formData.saldo_freenow} onChange={handleChange} /></Form.Group>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="p-3 border bg-light">
                            <Form.Group><Form.Label>Platnosci gotowka</Form.Label><Form.Control type="number" name="cash" value={formData.cash} onChange={handleChange} /></Form.Group>
                            <Form.Group><Form.Label>Bonus</Form.Label><Form.Control type="number" name="bonus" value={formData.bonus} onChange={handleChange} /></Form.Group>
                            <Form.Group><Form.Label>Tips</Form.Label><Form.Control type="number" name="tips" value={formData.tips} onChange={handleChange} /></Form.Group>
                        </Card>
                    </Col>
                </Row>
                <Button type="submit">{id ? t("edit") : t("add")}</Button>
            </Form>
        </Container>
    );
};

export default EditFreeNowInfo;
